module.exports = __webpack_public_path__ + "static/media/me3_Icon_EarnAdmission.251d90a6.svg";